import { connectionSlice } from "./reducer";

export const { getConnections,fetchTodos, setConnections } = connectionSlice.actions;

export default connectionSlice.actions;
